import { render, staticRenderFns } from "./FourthStrategy.vue?vue&type=template&id=ecaf77ea&scoped=true"
import script from "./FourthStrategy.vue?vue&type=script&scoped=true&lang=js"
export * from "./FourthStrategy.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./FourthStrategy.vue?vue&type=style&index=0&id=ecaf77ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf77ea",
  null
  
)

export default component.exports